import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Ticket, DollarSign, Users, Plus, ScanLine, ShoppingBag } from "lucide-react";
import { api, money } from "@/lib/api";

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-xl border border-[#27272A] bg-[#18181B] p-5">
      <Icon size={20} className="text-[#D4AF37]" />
      <p className="text-2xl font-bold text-white mt-3">{value}</p>
      <p className="text-xs text-zinc-400 mt-0.5">{label}</p>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-display text-3xl uppercase text-white mb-6">Dashboard</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <Stat icon={CalendarDays} label="Upcoming Events" value={stats?.upcoming_events ?? "—"} />
        <Stat icon={Ticket} label="Tickets Sold" value={stats?.tickets_sold ?? "—"} />
        <Stat icon={DollarSign} label="Gross Ticket Sales" value={stats ? money(stats.gross_sales) : "—"} />
        <Stat icon={Users} label="Total Customers" value={stats?.total_customers ?? "—"} />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-5">
        <Link to="/admin/events/new" data-testid="quick-create-event" className="btn-gold rounded-xl p-4 flex items-center gap-2 font-oswald tracking-wide text-sm"><Plus size={18} /> CREATE EVENT</Link>
        <Link to="/admin/checkin" className="rounded-xl border border-[#27272A] bg-[#18181B] p-4 flex items-center gap-2 font-oswald tracking-wide text-sm text-white hover:border-[#D4AF37]"><ScanLine size={18} /> CHECK-IN</Link>
        <Link to="/admin/orders" className="rounded-xl border border-[#27272A] bg-[#18181B] p-4 flex items-center gap-2 font-oswald tracking-wide text-sm text-white hover:border-[#D4AF37]"><ShoppingBag size={18} /> ORDERS</Link>
        <Link to="/admin/customers" className="rounded-xl border border-[#27272A] bg-[#18181B] p-4 flex items-center gap-2 font-oswald tracking-wide text-sm text-white hover:border-[#D4AF37]"><Users size={18} /> CUSTOMERS</Link>
      </div>

      <div className="mt-8">
        <h2 className="font-oswald text-sm tracking-widest text-zinc-400 uppercase mb-3">Recent Orders</h2>
        <div className="rounded-xl border border-[#27272A] overflow-hidden">
          {stats?.recent_orders?.length ? (
            <table className="w-full text-sm">
              <thead className="bg-[#18181B] text-zinc-400"><tr>
                <th className="text-left px-4 py-3 font-medium">Order</th>
                <th className="text-left px-4 py-3 font-medium">Customer</th>
                <th className="text-left px-4 py-3 font-medium hidden sm:table-cell">Event</th>
                <th className="text-right px-4 py-3 font-medium">Total</th>
              </tr></thead>
              <tbody>
                {stats.recent_orders.map((o) => (
                  <tr key={o.order_number} className="border-t border-[#27272A] text-zinc-200">
                    <td className="px-4 py-3 font-mono text-xs">{o.order_number}</td>
                    <td className="px-4 py-3">{o.customer}</td>
                    <td className="px-4 py-3 hidden sm:table-cell">{o.event}</td>
                    <td className="px-4 py-3 text-right text-[#D4AF37]">{money(o.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-10 text-center text-zinc-500">No orders yet.</div>
          )}
        </div>
      </div>
    </div>
  );
}
